import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-float-button',
    templateUrl: './float-button.component.html',
    styleUrls: ['./float-button.component.scss'],
    standalone: false
})
export class FloatButtonComponent implements OnInit {

  isButtonListVisible: boolean = false;

  constructor() {
    // This is intentional
  }

  ngOnInit() {
    // This is intentional
  }

  displayOptions() {
    this.isButtonListVisible = !this.isButtonListVisible;
  }

}
